import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SIP_CLIENT_ACTIONS, USER_STATE, CALL_KEY_MAX_LENGHT, INTEGRATION } from '../../../constants';
import { callIcon } from '../../../Images/Images';
import { updateInfoCall, messageChangeState } from '../../../redux/actions/A_messages_to_SM';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import TextareaAutosize from 'react-autosize-textarea';
import { Singleton } from '../../../js/Singleton';
import { validateCallKey } from '../../../js/helpers/Utils/Validations';
import { Button } from 'global-components-library';
import ContainerDataPreview from '../Others/ContainerDataPreview.jsx';

class CallWindow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			callkey: props.dataCall.CalKey ? props.dataCall.CalKey : props.extraDataCall.CalKey,
			cellKeyFocus: false,
			dataCall: props.dataCall,
			extraDataCall: props.extraDataCall,
			userState: props.userState,
			dataCells: props.dataCells
		};
		this.sharedData = new SingletonSharedData();
		this.language = new Singleton();
		this.integrationData=null;
	}

	componentDidMount() {
		this.setDataCells(this.props.dataCall.DataContact);
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.dataCall.CalKey !== nextProps.dataCall.CalKey){
			this.setState({
				dataCells: nextProps.dataCells,
			});
		}
		this.setState({
			dataCall: nextProps.dataCall,
			callkey: nextProps.dataCall.CalKey,
			userState: nextProps.userState,
			extraDataCall: nextProps.extraDataCall
		});

		if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
			this.integrationData = nextProps.messagesIntegrations.dataMessageIntegration;
			switch (this.integrationData.action) {
				case INTEGRATION.CALL_ACTION:
					if (this.integrationData.callAction === INTEGRATION.UPDATE_DATA_CALL) {
						let tempArray = this.state.dataCells;
						tempArray.map((item, i) => {
							item.text = this.integrationData.data[i];
						});
						this.setState({ dataCells: tempArray });
						this.updateInfo();
					}
					break;
				case INTEGRATION.EXIT_ASSISTED_MODE:
					this.exitAssistedMode();
					break;
				default:
					break;
			}
		}

		if (nextProps.sipClientActions.actionType === SIP_CLIENT_ACTIONS.HANGUP) {
			this.updateInfo();
		}
	}

	setDataCells(dataCellList) {
		if (dataCellList) {
			let tempArray = this.state.dataCells;
			tempArray.map(item => {
				return item.text === dataCellList[item.index] ? dataCellList[item.index] : item.text;
			});
			this.setState({ dataCells: tempArray, isChange: true });
		}
	}

	updateInfo = () => {
		var dataCallObj = this.state.dataCells.map(item => {
			return item.text ? item.text : '';
		});
		let callKey = this.props.dataCall.CalKey;
		let camID = this.props.iconCall.CamEspId;
		this.props.updateInfoCall(callKey, camID, dataCallObj,0);
		this.updateInfoCell(dataCallObj, callKey);
	};

	updateCallKey(callkey) {
		this.props.dataCall.CalKey = callkey;
	}

	getExtraClass(index) {
		var text = index >= 0 ? this.state.dataCells[index].text : this.state.callkey;
		var isFocus = index >= 0 ? this.state.dataCells[index].focus : this.state.cellKeyFocus;
		if (isFocus) {
			return index >= 0 ? ' cellFocus' : this.props.typeCall + 'Focus';
		}
		if (text) {
			return index >= 0 ? ' cellText' : this.props.typeCall + 'Text';
		}
		return index >= 0 ? ' cellNormal' : this.props.typeCall + 'Normal';
	}

	renderInfoCells() {
		let disableField =  false;

		if(this.props.iconCall && this.props.iconCall.EditableContactData != null){
			disableField = !this.props.iconCall.EditableContactData;
		}else{
			disableField = (this.props.dataCall.CallType === 1 && this.props.iconCall && !this.props.iconCall.CanReprogram) || this.state.userState.currentState === USER_STATE.OTHER
		}

		return this.state.dataCells.map(item => (
			<li className={`infoDataClientCell ${disableField ? 'infoDataClientCellDis':''}` + this.getExtraClass(item.index)} key={'cell' + item.index}>
				<p className='countCells'>{item.index + 1}</p>
				<TextareaAutosize
					disabled={disableField}
					className={`txtDataClientCell ${disableField ? 'disabled' : ''}`}
					maxLength={250}
					defaultValue={item.text}
					placeholder={this.language.getText('CallControlGUIContactDatanode') + ' ' + (item.index + 1)}
					onFocus={() => this.focusElement(item.index)}
					onBlur={event => this.unFocusElement(item.index, event.target.value)}
					onKeyPress={event => this.OnKeyPressEvent(item.index, event)}
				/>
			</li>
		));
	}

	OnKeyPressEvent = (index, e) => {
		var r = /^(\s*[a-zA-Z0-9-ZÀ-ÿ\u00f1\u00d1\u002F\u005F\u0024\u0020\u002E\u003A\u0027\u002C]*)*[a-zA-Z0-9-ZÀ-ÿ\u00f1\u00d1\u002F\u005F\u0024\u0020\u002E\u003A\u0027\u002C]+$/;
		if (e.charCode !== 8) {
			if (!r.test(String.fromCharCode(e.charCode))) {
				e.preventDefault();
			}
		}
	};

	focusElement = index => {
		if (index === -1) {
			this.setState({ cellKeyFocus: true });
		} else {
			let tempArray = this.state.dataCells;
			if (tempArray[index]) {
				tempArray[index].focus = true;
				this.setState({ dataCells: tempArray });
			}
		}
	};

	unFocusElement(index, dataValue) {
		let tempArray = this.state.dataCells;
		if (index >= 0) {
			tempArray[index].focus = false;
			tempArray[index].text = dataValue;
		}
	}

	updateInfoCell(dataCallArrary, callKey) {
		let dataCallObj = this.props.dataCall;
		dataCallObj.DataContact = dataCallArrary;
		dataCallObj.CalKey = callKey;
		this.props.saveDataCall(dataCallObj);
	}

	addingCallKey(e) {
		validateCallKey(e);
	}
	exitAssistedMode() {
		this.props.messageChangeState();
	}
	updateDataCallPreview = data => {
		this.props.updateInfoCall(data.callKey, data.camID, data.newData,data.callOutId);
	};

	OnKeyPressEventCallKey = (e) => {
		var r = /[!¡@#$%^&*()_+\-=\[\]{};':"\\|¬´°¨,.<>\/?]+$/;
		if (e.charCode !== 8) {
			if (r.test(String.fromCharCode(e.charCode))) {
				e.preventDefault();
			}
		}
	};

	render() {
		var id = this.props.dataCall.CallId ? this.props.dataCall.CallId : this.props.extraDataCall.CallId;
		const extraClass = !this.props.editableCallKey ? 'disabled' : this.getExtraClass(-1);0
		const showDataClient = ((this.props.userState.currentState === USER_STATE.DIALOG ) || (this.props.userState.currentState === USER_STATE.OTHER && this.props.showDataBySetting && this.props.extraDataCall.AgentXfer)
		) && this.sharedData.getDataPreviewPro().dialingMode == 0 ;
		const callKey = this.props.userState.currentState === USER_STATE.OTHER ? this.props.extraDataCall.CalKey :this.state.callkey
		return (
			<div className='callWindowContainer'>
				{this.sharedData.getCurrentState().toUpperCase() !== USER_STATE.ASSISTED && (
					<div className='infoCallContainer'>
						<p className='txtIdCall'>{this.language.getText('CallControlid') + ':' + Math.abs(id)}</p>
						<p className='txtDNISCall'>
							<b>{(this.props.dataCall.CallType === 1 || (this.props.dataCall.CallType === 1  && this.props.userState.currentState === USER_STATE.OTHER )) ? this.language.getText('CallControldnis') + ':' : ''}</b>
							{this.props.userState.currentState === USER_STATE.OTHER ? this.props.extraDataCall.DNIS : this.props.dataCall.DNIS}
						</p>
					</div>
				)}
				{this.sharedData.getDataPreviewPro().dialingMode === 1 && (this.props.previewActions.showData &&
					<ContainerDataPreview
						data={this.props.preview.data}
						headers={this.state.userState.currentState === USER_STATE.OTHER ? this.props.preview.headers : this.props.preview.record.DataHeaders}
						updateDataCallPreview={this.updateDataCallPreview}
						userState={this.state.userState.currentState}
						callKey={this.props.preview.callKey}
						disableInput={!this.props.preview.permissionUpdate}//{this.state.updatePvwData}
					/>)
				}
				{ showDataClient && (
					<div className='dataClient'>
						<div className='dataClientTitle'>{this.language.getText('CallControlGUIContactDatatitle')}</div>
						<div className={`infoDataClientContainer ${extraClass}`}>
							<img className='callKeyIcon' src={callIcon} alt='icon'></img>
							<div className='separatorIcon'></div>
							<input
								type='text'
								className='txtDataClient'
								defaultValue={callKey}
								placeholder={this.language.getText('GUICallSpacecallkey')}
								onFocus={() => this.focusElement(-1)}
								onBlur={event => this.unFocusElement(-1, event.target.value)}
								readOnly={!this.props.editableCallKey}
								maxLength={CALL_KEY_MAX_LENGHT}
								onKeyPress={this.OnKeyPressEventCallKey}
								onChange={event => {
									this.updateCallKey(event.target.value);
								}}
							/>
						</div>
						<ul className='infoDataClientScroll'>
							<div>{this.renderInfoCells()}</div>
						</ul>
						<p className={`buttonChangeInfo ${this.props.iconCall && !this.props.iconCall.EditableContactData ? 'disabled' : ''}`} onClick={this.updateInfo}>
							{this.language.getText('CallControlGUIContactDatabuttom')}
						</p>
					</div>
				)}
				{this.state.userState.currentState === USER_STATE.ASSISTED && this.sharedData.getIsEnableBtnExitAssited() === true && (
					<div className='callWindowBtn'>
						<div className='buttonExitAssited'>
							<Button id='BtnExitAssited' onClick={() => this.exitAssistedMode()}>
								<i id='IconAssistedNegation' className='gcl-icon assisted-negation' />
								<p>{this.language.getText('GUIAssistedCallexitAssisted')}</p>
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		sipClientActions: state.sipClientActions,
		userState: state.userState,
		messagesIntegrations: state.messagesIntegrations,
		preview: state.preview,
		previewActions: state.previewActions,
		showDataBySetting: state.transferReducer.showDataBySetting
	};
}

function mapDispatchToProps(dispatch) {
	return {
		updateInfoCall: (callKey_A, camID_A, phoneNumber_A, dataUsers_A,callOutId_A) => {
			dispatch(updateInfoCall(callKey_A, camID_A, phoneNumber_A, dataUsers_A,callOutId_A));
		},
		messageChangeState: () => {
			dispatch(messageChangeState());
		}
	};
}

export default CallWindow = connect(mapStateToProps, mapDispatchToProps)(CallWindow);



// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/CallWindow.jsx